import React, { useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { cloneDeep, get, isEmpty } from 'lodash';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import ImportImagineDocumentButton from 'containers/CourtManagerLegalProceedings/ImagineDocuments/ImportButton';
import { resolveSagisClaim } from 'helpers/utils';
import { Listings } from 'containers/AppContainer/typings';
import { JudgementAddFormContainer } from 'containers/LawyerLegalProceedingsPage/judgementAdd/JudgementAddPronouncing/styled-components';
import ExpertiseAddForms from 'containers/LawyerLegalProceedingsPage/judgementAdd/JudgementAddPronouncing/ExpertiseAddForms';
import { Vehicule } from 'containers/PreOpeningPage/typings';
import {
  ExpertiseState,
  JudgementADDDocumentType,
} from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { EMPTY_EXPERTISE } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/constants';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import {
  isJudgementValid,
  judgementAddValidator,
} from 'containers/LawyerLegalProceedingsPage/judgementAdd/JudgementAddPronouncing/validator';
import { formattedJudgementAddPronouncing } from 'containers/LawyerLegalProceedingsPage/judgementAdd/JudgementAddPronouncing/utils';
import JudgementAddFormFields from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/JudgementAddFormFields';
import FormValidationButtons from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/FormValidationButtons';
import { arrayTranslate } from 'containers/services/translate';
import { displayErrorText } from 'containers/services/validateForm';
import UploadDocumentBloc from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/UploadDocumentBloc';
import { APPEAL_DOC_ID } from 'containers/LawyerLegalProceedingsPage/AppealAdd/constants';
import { DOCUMENT_TYPES } from 'constants/global';
import { Grid } from '@material-ui/core';
import { VictimType } from 'typings/globalTypes';
export interface JudgementAddPronouncingFormProps {
  intl: IntlShape;
  listings: Listings;
  victims: VictimType[];
  vehicules: Vehicule[];
  judgementAddPronouncing: JudgementADDDocumentType;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  handleSetJudgementAddPronouncing: Function;
  index: number;
  details: any;
  saveForm: Function;
  cancelJudgement: Function;
  indexMap?: number;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  imagineDocuments: any;
  claimId: number;
  policyInfo: any;
  isManager: boolean;
  requestGetDocByDocumentumId: Function;
}

const JudgementAddPronouncingForm: React.FC<JudgementAddPronouncingFormProps> = (
  props,
): JSX.Element => {
  const [expertises, setExpertises] = useState<ExpertiseState[]>([
    cloneDeep(EMPTY_EXPERTISE),
  ]);

  const [disabledSaveButton, setDisabledSaveButton] = useState<boolean>(true);
  const [judgementAddValidation, setJudgementAddValidation] = useState<any>({});
  const [messageJudgementError, setMessageJudgementError] = useState<any>({});

  React.useEffect(() => {
    const judgementAdd = formattedJudgementAddPronouncing(
      expertises,
      props.victims,
      props.vehicules,
      props.judgementAddPronouncing,
    );

    const validateJudgementAdd = judgementAddValidator(judgementAdd);
    setJudgementAddValidation(validateJudgementAdd);
    const translateArrayErrorMessages = arrayTranslate(
      props.intl.formatMessage,
    );
    const { message } = displayErrorText(
      validateJudgementAdd,
      translateArrayErrorMessages(validateJudgementAdd, true),
    );
    setMessageJudgementError(message);
    setDisabledSaveButton(
      !isJudgementValid(judgementAdd, get(props.details, 'hearingDate', '')) ||
        get(props.judgementAddPronouncing, 'judgementDate') === 'Invalid date',
    );
  }, [
    expertises,
    props.judgementAddPronouncing,
    props.vehicules,
    props.victims,
  ]);

  const handleSaveJudgementAddDocument = () => {
    const judgementAdd = formattedJudgementAddPronouncing(
      expertises,
      props.victims,
      props.vehicules,
      props.judgementAddPronouncing,
    );

    props.saveForm(judgementAdd);

    setExpertises([]);
    props.handleSetJudgementAddPronouncing({});
  };

  const handleCancelJudgementAdd = () => {
    props.cancelJudgement();
  };
  const getIndex = () => {
    return props.indexMap !== undefined ? props.indexMap : props.index;
  };
  return (
    <JudgementAddFormContainer>
      <JudgementAddFormFields
        index={props.index}
        handleSetJudgementAddPronouncing={
          props.handleSetJudgementAddPronouncing
        }
        judgementAddPronouncing={props.judgementAddPronouncing}
        listings={props.listings}
        details={props.details}
        judgementAddValidation={judgementAddValidation}
        messageJudgementError={messageJudgementError}
        hearingDate={get(props.details, 'hearingDate', '')}
      />
      <section className="expertise-form">
        <ExpertiseAddForms
          judgementAddPronouncing={props.judgementAddPronouncing}
          listings={props.listings}
          victims={props.victims}
          vehicules={props.vehicules}
          expertises={expertises}
          setExpertises={setExpertises}
          sagisVictimInfo={props.sagisVictimInfo}
          sagisOpposingParties={props.sagisOpposingParties}
        />
      </section>
      <Grid container direction="row" alignItems={'center'} spacing={2}>
        <Grid item xs={4}>
          <UploadDocumentBloc
            docType={DOCUMENT_TYPES.APPEAL_ADD}
            docId={APPEAL_DOC_ID}
            document={props.judgementAddPronouncing}
            setDocument={props.handleSetJudgementAddPronouncing}
            index={getIndex()}
            resetUploadedDocument={props.resetUploadedDocument}
            uploadDocument={props.uploadDocument}
            uploadedDocument={props.uploadedDocument}
          />
        </Grid>
        <Grid item xs={4} style={{ marginTop: '45px' }}>
          {!isEmpty(props.imagineDocuments) &&
            props.isManager &&
            featureService.hasFeature(FEATURES.TRAITEMENT_IMAGINE_DOC) && (
              <ImportImagineDocumentButton
                listings={props.listings}
                managerNotifcationsInboxes={props.imagineDocuments}
                claimId={props.claimId}
                imagineDocuments={props.imagineDocuments}
                claimSagisInfo={resolveSagisClaim(props.policyInfo)}
                uploadDocument={props.uploadDocument}
                uploadedDocument={props.uploadedDocument}
                setUploadedDocs={props.handleSetJudgementAddPronouncing}
                documentName={DOCUMENT_TYPES.JUDGEMENT_ADD}
                documentType={DOCUMENT_TYPES.JUDGEMENT_ADD}
                documentId={''}
                setDocumentId={/* istanbul ignore next */ () => {}}
                document={props.judgementAddPronouncing}
                requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
              />
            )}
        </Grid>
      </Grid>

      <FormValidationButtons
        saveForm={handleSaveJudgementAddDocument}
        cancelForm={handleCancelJudgementAdd}
        disabled={disabledSaveButton}
      />
    </JudgementAddFormContainer>
  );
};

export default injectIntl(JudgementAddPronouncingForm);
